export const Paypal = () => {
    return (
        <div>
            <p>Work in progress. Our team is working hard to bring you this option</p>
        </div>
    )
}